import * as types from "../types";
import { requestAuth } from "../../helpers/FetchApi";
import appSettings from "../../AppSettings";
import { ActionsCreators } from "../../actions";
import { toast } from "react-toastify";
import strings from "../../helpers/Localization";

export const actionCreators = {
    GetUserGroupsList: (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess, secondary) => async (dispatch, store) => {
        secondary ? dispatch({ type: types.GET_USERGROUPS_SECONDARY_COMPLETED, payload: null }) : dispatch({ type: types.GET_USERGROUPS_COMPLETED, payload: null });
        if (pageSize < 0) {return onSuccess(null);}
        await requestAuth(appSettings.SKALINKAPIURL + "/api/UserGroups/OrganizationUserGroups/" + store().currentuser.currentorganization.id + "?"
                + "pageNumber=" + pageNumber
                + "&pageSize=" + pageSize
                + (sortExpression ? "&sortExpression=" + sortExpression : "")
                + (filterExpression ? "&filterExpression=" + filterExpression : "")
        , {
            method: "GET"
        }).then((data) => {
            data.sortExpression = sortExpression;
            data.filterExpression = filterExpression;
            data.tagSearchRequest = tagSearchRequest;
            data.PaginationType = PaginationType;
            secondary ? dispatch({ type: types.GET_USERGROUPS_SECONDARY_COMPLETED, payload: data }) : dispatch({ type: types.GET_USERGROUPS_COMPLETED, payload: data });
            return onSuccess(data);
        }).catch( (data) => {
            console.log(data);
        });
    },
    SaveUserGroupsPagination: (paginationType) => (dispatch, store) => {
        const data = store().administration.usergroups;
        dispatch({ type: types.GET_USERGROUPS_COMPLETED, payload: { ...data, PaginationType: paginationType } });
    },

    GetSecondaryUserGroupsList: (onSuccess) => async (dispatch, store) => {
        dispatch({ type: types.GET_USERGROUPS_SECONDARY_COMPLETED, payload: null });
        await requestAuth(appSettings.SKALINKAPIURL + "/api/UserGroups/AllOrganizationUserGroups/" + store().currentuser.currentorganization.id,
            {
                method: "GET"
            }).then((data) => {
            dispatch({ type: types.GET_USERGROUPS_SECONDARY_COMPLETED, payload: { results: data } });
            return onSuccess({ results: data });
        }).catch( (data) => {
            console.log(data);
        });
    },

    GetUserGroup: (id, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/UserGroups/" + id, {
            method: "GET"
        }).then((data) => {
            return onSuccess(data);
        }).catch( (data) => {
            console.log(data);
        });
    },

    DeleteUserGroup: (userGroupId, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/UserGroups/" + userGroupId, {
            method: "DELETE"
        }).then((data) => {
            toast.success(strings.ugDeleted);
            return onSuccess(data);
        }).catch( (data) => {
            console.log("error", data);
        });
    },

    EditUserGroup: (changedUserGroup, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/UserGroups/" + changedUserGroup.id, {
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(changedUserGroup),
            method: "PUT"
        }).then((data) => {
            toast.success(strings.ugSaved);
            return onSuccess(data);
        }).catch( (data) => {
            console.log("error", data);
        });

    },

    CreateUserGroup: (newUserGroup, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/UserGroups", {
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(newUserGroup),
            method: "POST"
        }).then((data) => {
            toast.success(strings.ugSaved);
            return onSuccess(data);
        }).catch( (data) => {
            console.log("error", data);
        });
    }

};
